import { memo } from 'react';
import { twJoin } from 'tailwind-merge';

import { bodyTextLarge } from '@/styles/styles';

type Props = {
  title: string;
};

function ProgressCollectionTitle(props: Props) {
  const { title } = props;

  return (
    <h2 className={twJoin(bodyTextLarge, 'text-base-content font-500')}>
      {title}
    </h2>
  );
}

export default memo(ProgressCollectionTitle);
